import { IRole, ITeam } from '~/store/user/types';
import { IDictionary } from '../dictionaries/types';
import { IAddressExtended } from '../types';

export enum UserStatus {
  ACTIVE = 'Active',
  PENDING = 'Pending',
  DEACTIVATED = 'Deactivated',
  LOCKED = 'Locked',
}

export type Status =
  | UserStatus.ACTIVE
  | UserStatus.PENDING
  | UserStatus.DEACTIVATED
  | UserStatus.LOCKED;

interface Common {
  id: number;
  firstName: string;
  lastName: string;
  email: string;
  status: Status;
}

export interface IActTeamMember extends Common {
  primaryRole?: IDictionary;
  roles?: IRole[];
  isArchived?: boolean;
  teams?: ITeam[];
}

export interface IAssignableActTeamMember {
  id: number;
  name: string;
  roles: { id: number; name: string }[];
}

export interface IActTeamMemberAvailableList extends Common {
  sendBirdUserId: string;
  photo: string;
  subRoles: IDictionary[];
  education: IDictionary;
  teams: IDictionary[];
  roles: IRole[];
  primaryRole: IDictionary;
  isDeleted: boolean;
  isActive: boolean;
}

export interface IActTeamMemberExtended extends IActTeamMemberAvailableList {
  phone: string;
  address: IActTeamMemberAddress;
}

interface ExtendedDictionary extends IDictionary {
  abbreviation: string;
}

interface IActTeamMemberAddress extends IAddressExtended {
  state: ExtendedDictionary;
}
